// @flow
import keyBy from 'lodash/keyBy';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { tripica } from '../../api';
import config from '../../config';
import { injectMockRoamingSubscriptionOptions } from '../../lib/mockRoamingOptions';
import { setError, setLoading } from '../LoadingStatus';
import { fetchAllFailure, fetchAllSuccess } from './actions';
import { SubscriptionsByOuidType } from './types';
import WizzeeLog from '../../lib/wizzeeLog';

export function* fetchAllSubscriptionsSaga(): Generator<*, *, *> {
  yield put(setLoading('fetchAllSubscriptions', true));
  try {
    const catalog = yield call([tripica, 'getCatalog']);
    let subscriptions = yield call([tripica, 'getSubscriptions']);
    subscriptions = tripica.formatter.addHasUnavailbleOffersKeyToSubscriptions(catalog, subscriptions);
    subscriptions = injectMockRoamingSubscriptionOptions(subscriptions, config.enableRoamingOptionsMockInCurrentSubscription);

    const subscriptionsByOuid: SubscriptionsByOuidType = keyBy(subscriptions, 'ouid');

    yield put(fetchAllSuccess(subscriptionsByOuid));
  } catch (e) {
    WizzeeLog.warn('[saga] fetchAllSubscriptionsSaga', e);
    yield put(setError('fetchAllSubscriptions', e));
    yield put(fetchAllFailure(e));
  } finally {
    yield put(setLoading('fetchAllSubscriptions', false));
  }
}

export function* saga(): Generator<*, *, *> {
  yield all([takeLatest('SUBSCRIPTION_FETCH_ALL', fetchAllSubscriptionsSaga)]);
}
